module.exports = __webpack_public_path__ + "img/hourTime.5cf3a0a2.png";